import { Button, Flex, Text } from "@chakra-ui/react";
import { Modal } from "antd";
import React from "react";

// Claude: extracted from Buyer.tsx 23-03-2026
// Claude: two-choice delete when event filter active — unlink or full delete 07-Apr-2026
interface Props {
  isOpen: boolean;
  onClose: () => void;
  sortEventId: string;
  selectAllDB: boolean;
  totalBuyersCount: number;
  excludedIds: string[];
  selectedRowKeys: any[];
  onConfirmDelete: () => void;
  onConfirmUnlink?: () => void;
}

const BuyerDeleteModal = ({
  isOpen, onClose, sortEventId, selectAllDB, totalBuyersCount, excludedIds, selectedRowKeys, onConfirmDelete, onConfirmUnlink,
}: Props) => {
  const count = selectAllDB ? totalBuyersCount - excludedIds.length : selectedRowKeys.length;
  return (
    <Modal title="Alert" footer={null} onCancel={onClose} open={isOpen}>
      <Text my={5} mt={8}>
        {sortEventId ? (
          <>
            Delete request received for <strong>{count} buyer{count !== 1 ? "s" : ""}</strong>. You are filtering by a specific event. Please choose an action:
          </>
        ) : (
          <>
            <strong>{count} buyer{count !== 1 ? "s" : ""}</strong> will be permanently deleted. This action cannot be undone. Are you sure?
          </>
        )}
      </Text>
      <Flex justifyContent="center" gap={3} flexWrap="wrap">
        <Button display="flex" justifyContent="center" alignItems="center" h="100%"
          background="#0E122F" color="white" px={3} py={1} _hover={{ background: "#2E7D32" }}
          onClick={onClose}
        >
          Cancel
        </Button>
        {sortEventId && onConfirmUnlink && (
          <Button display="flex" justifyContent="center" alignItems="center" h="100%"
            background="blue.600" color="white" px={3} py={1} _hover={{ background: "blue.800" }}
            onClick={onConfirmUnlink}
          >
            Unlink from selected event
          </Button>
        )}
        <Button display="flex" justifyContent="center" alignItems="center" h="100%"
          background="secondary.light" color="secondary.main" px={3} py={1}
          _hover={{ background: "#C62828", color: "white" }}
          onClick={onConfirmDelete}
        >
          Delete Buyer completely
        </Button>
      </Flex>
    </Modal>
  );
};

export default BuyerDeleteModal;
